export enum GiftboxesErrorCodes {

}
